// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__1l8Zm","namePhoneContainer":"style_namePhoneContainer__3bS41"};